import { Component } from '@angular/core';
import { ToastController,LoadingController,NavController,AlertController  } from 'ionic-angular';
import { Usuario } from '../../entities/usuario';
import { UsuarioDAO } from '../../daos/usuario-dao';
import { AppModule } from '../../app/app.module';
import { EmpresaUsuario } from '../../entities/empresa-usuario';
import { LoginPage } from '../../pages/login/login';
import { EnviarEmailSenhaPage } from '../../pages/enviar-email-senha/enviar-email-senha';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';



@Component({
    selector: 'page-cadastro-usuario',
    templateUrl: 'cadastro-usuario.html'
})
export class CadastroUsuarioPage {
    public formCadUsuario: FormGroup;
    public usuario: Usuario;
    public empresaUsuario : EmpresaUsuario;
    public empresaUsuarioMascara= '';
    mostrarsenha: boolean = false;

    cnpj: string = "";
    v: string;
  
    constructor(private _loadingCtrl: LoadingController,public navCtrl: NavController
      ,private _formBuilder: FormBuilder,private _alertCtrl: AlertController
      ,private _usuarioDao: UsuarioDAO,private _toastCtrl: ToastController) {
        this.formCadUsuario = this._formBuilder.group({
          NomeUsuario: ['', Validators.compose([Validators.required, Validators.minLength(1)])],
          CpfUsuario: ['', Validators.compose([Validators.required, Validators.minLength(1)])],
          Email: ['', Validators.compose([Validators.required, Validators.minLength(1)])],
          Senha: ['', Validators.compose([Validators.required, Validators.minLength(1)])],
          Fone: ['', Validators.compose([Validators.required, Validators.minLength(1)])],          
          DtAniversario: ['', ''],
          IdentificacaoLoja: ['', Validators.compose([Validators.required, Validators.minLength(1)])],
          Informativo: ['', '']

      }); 
        
 
    }

    format_Cnpj(v) {
        v = v.replace(/\D/g, ''); //Remove tudo o que não é dígito
        v = v.replace(/^(\d{2})(\d)/, '$1.$2'); //Coloca ponto entre o segundo e o terceiro dígitos
        v = v.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3'); //Coloca ponto entre o quinto e o sexto dígitos
        v = v.replace(/\.(\d{3})(\d)/, '.$1/$2'); //Coloca uma barra entre o oitavo e o nono dígitos
        v = v.replace(/(\d{4})(\d)/, '$1-$2'); //Coloca um hífen depois do bloco de quatro dígitos
        return v;
    }

    async obterUsuario() {            
        if (this.cnpj.length){
            let load = this._loadingCtrl.create({ content: 'Obtendo dados da Empresa...' });
            load.present();           

            this._usuarioDao.obterEmpresaUsuario(this.cnpj,AppModule.getEmpresa().Id).then(retorno =>{
                if (retorno.CnpjEmpresaUsuario != null) {
                  this.empresaUsuario = retorno; 
                  this.empresaUsuarioMascara = this.empresaUsuario.CnpjEmpresaUsuario;
                  this.empresaUsuarioMascara =  this.format_Cnpj(this.empresaUsuarioMascara);                
                  load.dismiss();
                  setTimeout(() => {
                    this.usuario = new Usuario();
                  }, 1000);
                }else{
                  throw new SyntaxError("CNPJ não foi localizado.");
                }
                
              }).catch(error => {
                this._toastCtrl.create({
                    message: 'Ocorreu um erro ao tentar obter dados da Empresa.',
                    duration: 3000
                }).present();
                console.error(error);
                load.dismiss();
              });



        }           
    }

  /*
    apenasNumero(event) {  

      let verificar = false;
      let letraspermitidas="0123456789";

     let key = event.key;

      for (let letra of letraspermitidas ){
        
        if (key == letra){
          verificar = true;
        }
      }      
      
    
      if (verificar){
        return true;
      }else{
        this._toastCtrl.create({
          message: 'Digite apenas números!',
          duration: 3000
        }).present();
        this.usuario.CpfUsuario = "";   
        return;             
      }    
        
   
      
    }
    */

    apenasLetraNumero(event) {  

      let verificar = false;
      let letraspermitidas="ABCEDFGHIJKLMNOPQRSTUVXWYZabcdefghijklmnopqrstuvxwy0123456789";

     let key = event.key;

      for (let letra of letraspermitidas ){
        
        if (key == letra){
          console.log(letra);
          verificar = true;
        }
      }
      
      
      if (verificar){
        return true;
      }else{
        this._toastCtrl.create({
          message: 'Digite apenas letras ou números!',
          duration: 3000
        }).present();
        this.usuario.Senha = "";   
        return;             
      }    
   
      
    }

    alternarVisibilidadeSenha() {
      this.mostrarsenha = !this.mostrarsenha;
    }

    cadastrarUsuario() {
      if (this.formCadUsuario.invalid) {
        this._toastCtrl.create({
            message: 'O formulário está invalido. Favor Verifique!',
            duration: 3000
        }).present();

        return;
      }

      if (this.usuario.CpfUsuario && this.usuario.Senha) {
        this.usuario.Ativo = '1';
        this.usuario.CnpjEmpresaUsuario = this.empresaUsuario.CnpjEmpresaUsuario;
        this.usuario.NomeEmpresaUsuario = this.empresaUsuario.NomeEmpresaUsuario;
        this.usuario.Perfil = 'VENDEDOR';
        this.usuario.Empresa = AppModule.getEmpresa();
        this.salvarUsuario();
      }
    }

    salvarUsuario() {
      this._usuarioDao.adicionarUsuario(this.usuario)
          .then(retorno => {
            
            //
            if (retorno=='ok'){
              this.alertaDeSucesso('Cadastro efetuado com sucesso');
              this.navCtrl.setRoot(LoginPage); 
            }else{

              this._alertCtrl.create({
                message: 'Deseja ser redirecionado para página esqueci minha senha',
                title: retorno,
                buttons: [
                  {
                      text: 'Não',
                      role: 'destructive'
                  },
                  {
                      text: 'Sim',
                      handler: (data) => {
                        this.navCtrl.push(EnviarEmailSenhaPage);                                             
                            
                      }
                  }
              ]
          }).present();

            
/*
              this._toastCtrl.create({
                  message: retorno ,
                  duration: 3000
              }).present();
              this.navCtrl.push(EnviarEmailSenhaPage);
              return;
              */
            }
            //


          }, e => {
              console.error('Não foi possível adicionar o usuário.');
          });
    }


    cancelarCadastro() {
        this.usuario = null;
    }

    alertaDeSucesso(msg: string) {
      this._alertCtrl.create({
          message: msg,
          title: 'Sucesso 😀 ️',
          buttons: [{
              text: 'Ok'
          }]
      }).present();
  }


}


// WEBPACK FOOTER //
// ./src/pages/cadastro-usuario/cadastro-usuario.ts